module.exports = __webpack_public_path__ + "img/loading-spinner-large.8cebf0c6.svg";